import React, { useEffect, useState } from 'react';
import { Card, Empty, Spin, Typography } from 'antd';
import systemService from '../../services/systemService';

const { Text } = Typography;

// L2 调度受 CDN_L2_TOPOLOGY_ENABLED 控制；关闭时只显示一张禁用卡片，开启（或读取失败）时渲染原页面。
const L2Gate = ({ title, children }) => {
    const [state, setState] = useState('loading');

    useEffect(() => {
        let alive = true;
        systemService.getRuntimeSettings()
            .then((r) => {
                if (!alive) return;
                const off = r && r.success && !r.data?.CDN_L2_TOPOLOGY_ENABLED?.value;
                setState(off ? 'off' : 'on');
            })
            .catch(() => alive && setState('on'));
        return () => { alive = false; };
    }, []);

    if (state === 'loading') {
        return <Card title={title}><Spin /></Card>;
    }
    if (state === 'off') {
        return (
            <Card title={title}>
                <Empty
                    description={
                        <>
                            <div>二级缓存暂未启用</div>
                            <Text type="secondary">开启 CDN_L2_TOPOLOGY_ENABLED 后可在此管理</Text>
                        </>
                    }
                />
            </Card>
        );
    }
    return children;
};

export default L2Gate;
